import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    EquipoHistorial: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_EQUIPOS_HISTORIAL = 'GET_ALL_EQUIPOS_HISTORIAL'
const GET_EQUIPO_HISTORIAL_BY_ID = 'GET_EQUIPO_HISTORIAL_BY_ID'
const POST_EQUIPO_HISTORIAL = 'POST_EQUIPO_HISTORIAL'
const UPDATE_EQUIPO_HISTORIAL = 'UPDATE_EQUIPO_HISTORIAL'
const DELETE_EQUIPO_HISTORIAL = 'DELETE_EQUIPO_HISTORIAL'
//*******************************************************************************************************************


//MÉTODOS 
export const getAllEquiposHistorial = createAsyncThunk(
    GET_ALL_EQUIPOS_HISTORIAL,
    async () => {
        try {
            const fullUrl = host + `Fi25anexoEquipoHistorial/obtenerEquiposHistorial`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen las EquipoHistorials: '+JSON.stringify(res.data))
            return res
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const getEquipoHistorialById = createAsyncThunk(
    GET_EQUIPO_HISTORIAL_BY_ID,
    async (idEquipoHistorial) => {
        try {
            const fullUrl = host + `Fi25anexoEquipoHistorial/obtenerEquipoHistorialById/${idEquipoHistorial}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertEquipoHistorial = createAsyncThunk(
    POST_EQUIPO_HISTORIAL,
    async (data) => {
        try {
            const fullUrl = host + `Fi25anexoEquipoHistorial/agregarEquipoHistorial`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateEquipoHistorial = createAsyncThunk(
    UPDATE_EQUIPO_HISTORIAL,
    async (data) => {
        try {
            const fullUrl = host + `Fi25anexoEquipoHistorial/actualizarEquipoHistorial`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const deleteEquipoHistorial = createAsyncThunk(
    DELETE_EQUIPO_HISTORIAL,
    async (idEquipoHistorial) => {
        try {
            const fullUrl = host + `Fi25anexoEquipoHistorial/eliminarEquipoHistorial/${idEquipoHistorial}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosEquipoHistorialSlice = createSlice({

    name: 'metodosEquipoHistorialSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllEquiposHistorial.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.EquipoHistorial = payload.data.data

        },
        [getEquipoHistorialById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.EquipoHistorial = payload.data.data
        },
        [insertEquipoHistorial.fulfilled]: (state, { payload }) => {
            state.EquipoHistorial = payload.data.data
        },

        [updateEquipoHistorial.fulfilled]: (state, { payload }) => {

        },
        [deleteEquipoHistorial.fulfilled]: (state, { payload }) => {

        },

    },

})


export const { } = metodosEquipoHistorialSlice.actions
export const EquipoHistorialReducer = metodosEquipoHistorialSlice.reducer